import React, {useEffect} from 'react'
import {Lang} from 'yougile-lang'
import {ReportTimetrackingFilter} from 'yougile-model'
import {Option} from '@components/common/select/select'
import {DropdownList} from '@components/common/dropdown-list/dropdown-list'
import {Remove} from '@components/statistics/stats-reports/common'

interface OuterProps {
  filter: ReportTimetrackingFilter
}

interface Props extends OuterProps {
  update: (filters: ReportTimetrackingFilter) => void
}

export const TimetrackingFilter = (props: Props) => {
  const {filter = {}, update} = props

  useEffect(() => {
    if (!props.filter) {
      props.update({})
    }
  }, [props.filter])

  const planOpts = getPlanOpts()
  const workOpts = getWorkOpts()

  const planChange = (value: '' | ReportTimetrackingFilter['plan']) => {
    if (value === '') {
      const {plan: _, ...newFilter} = filter
      update(newFilter)
    } else {
      update({...filter, plan: value})
    }
  }
  const workChange = (value: '' | ReportTimetrackingFilter['work']) => {
    if (value === '') {
      const {work: _, ...newFilter} = filter
      update(newFilter)
    } else {
      update({...filter, work: value})
    }
  }

  return (
    <div>
      <div className="flex justify-between mb-8">
        <DropdownList
          className="w-184"
          initialOpen={!props.filter}
          options={planOpts}
          value={filter.plan || ''}
          onChange={planChange}
        />
        <Remove update={update} />
      </div>
      <div className="flex justify-between">
        <DropdownList
          className="w-184"
          options={workOpts}
          value={filter.work || ''}
          onChange={workChange}
        />
      </div>
    </div>
  )
}

const getPlanOpts = () => {
  const planOpts: Array<
    Option & {
      value: '' | ReportTimetrackingFilter['plan']
    }
  > = [
    {value: '', label: Lang.msg.statsFilterAny},
    {value: 'not-set', label: Lang.msg.statsTimetrackingNotSet},
    {value: 'set', label: Lang.msg.statsTimetrackingSet}
  ].map((o: Option<'' | ReportTimetrackingFilter['plan']>) => ({
    ...o,
    label: Lang.msg.tsPlan + ': ' + o.label
  }))

  return planOpts
}

const getWorkOpts = () => {
  const workOpts: Array<Option<'' | ReportTimetrackingFilter['work']>> = [
    {value: '', label: Lang.msg.statsFilterAny},
    {value: 'not-set', label: Lang.msg.statsTimetrackingNotSet},
    {value: 'set', label: Lang.msg.statsTimetrackingSet},
    {value: '<=plan', label: Lang.msg.statsTimetrackingNotExceedsPlan},
    {value: '>plan', label: Lang.msg.statsTimetrackingExceedsPlan}
  ].map((o: Option<'' | ReportTimetrackingFilter['work']>) => ({
    ...o,
    label: Lang.msg.tsWork + ': ' + o.label
  }))

  return workOpts
}

export const TimetrackingFilterValue = (props: OuterProps) => {
  const filter = props.filter ?? {}
  const planOpts = getPlanOpts()
  const workOpts = getWorkOpts()

  const planValue = planOpts.find(opt => opt.value === filter.plan)
  const workValue = workOpts.find(opt => opt.value === filter.work)

  return (
    <>
      <div>{planValue?.label ?? planOpts[0].label}</div>
      <div>{workValue?.label ?? workOpts[0].label}</div>
    </>
  )
}
